export default __webpack_public_path__ + "static/works-image2-36cc81f237099def454b30a1c1698ade.jpg";